import React, { useState } from "react";
import { IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { withStyles } from "@mui/styles";
import { gradientIconStyles } from "../../styles/formFieldGradientIcon";

export type UsePasswordFieldHook = {
  type?: string;
  EndIcon?: React.JSX.Element;
};
const StyledVisibility = withStyles(gradientIconStyles)(Visibility);
const StyledVisibilityOff = withStyles(gradientIconStyles)(VisibilityOff);

export const usePasswordField = (): UsePasswordFieldHook => {
  const [type, setType] = useState("password");

  const onClick = () =>
    setType((prevType: string): string =>
      prevType === "password" ? "text" : "password"
    );

  const onMouseDown = (e: React.SyntheticEvent<HTMLButtonElement>) =>
    e.preventDefault();

  const EndIcon = (
    <IconButton
      data-testid="end-icon"
      onClick={onClick}
      onMouseDown={onMouseDown}
    >
      {type === "password" ? (
        <StyledVisibility data-testid="visibility-on-icon" />
      ) : (
        <StyledVisibilityOff data-testid="visibility-off-icon" />
      )}
    </IconButton>
  );
  return {
    type,
    EndIcon,
  };
};
